module.exports = __webpack_public_path__ + "static/media/Maf_CiberSegNoticias.87b587fb.jpg";